/**
 * Best-effort server-side sign-out. Plain "Sign out" used to forget the token in the browser only, so on a shared
 * tablet the old token stayed valid until it expired. This asks the server to revoke THIS session's token.
 *
 * It is issued before the caller clears local state (the token is read here, now), and it never blocks or throws:
 * offline, a 401 (token already dead) or a slow network must not stop the person signing out.
 */
export function signOutOnServer({ apiUrl, token, fetchImpl }) {
  const doFetch = fetchImpl || (typeof fetch === 'function' ? fetch : null);
  const current = (typeof localStorage !== 'undefined' && localStorage.getItem('token')) || token;
  if (!current || !doFetch) return Promise.resolve(false);
  try {
    return Promise.resolve(doFetch(`${apiUrl}/api/auth/logout`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${current}` },
      keepalive: true,
    })).then((res) => !!(res && res.ok), () => false);
  } catch {
    return Promise.resolve(false);
  }
}
